import { picoapp } from 'picoapp'

import header from './components/header'
import accountLogin from './components/accountLogin'
import accountAddress from './components/accountAddress'
import accountNewAddress from './components/accountNewAddress'
import inputText from './components/inputText'
import inputCheckbox from './components/inputCheckbox'
import inputSelect from './components/inputSelect'

const components = {
  header,
  accountLogin,
  accountAddress,
  accountNewAddress,
  inputText,
  inputCheckbox,
  inputSelect,
}

const state = {
  isMobileMenuOpen: false,
}

export default picoapp(components, state)
